/**
 * Conditionally loads the Crisp chat script.
 * Not loaded for ACOM admins (they use admin console, not support chat).
 */
import { useEffect, useRef } from "react";
import { useAcomAdmin } from "@/hooks/use-acom-admin";

const CRISP_WEBSITE_ID = "821dea7e-2add-4621-894e-166bee63252f";

export function SupportCrisp() {
    const { isAcomAdmin, isLoaded } = useAcomAdmin();
    const injected = useRef(false);

    useEffect(() => {
        if (!isLoaded || isAcomAdmin || injected.current) return;
        injected.current = true;

        if (typeof window === "undefined") return;
        // Crisp bootstrap: queue and website id (script reads these)
        const w = window as unknown as { $crisp: unknown[]; CRISP_WEBSITE_ID: string };
        w.$crisp = [];
        w.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://client.crisp.chat/l.js";
        script.async = true;
        document.head.appendChild(script);
    }, [isLoaded, isAcomAdmin]);

    return null;
}
